import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { useFilter } from '../../hooks/useFilter';
import { usePages } from '../../hooks/usePages';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';
import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { Layout } from '../../components/Layout';
import { SearchTextField } from '../../components/SearchTextField';

import { TipoPersonaProps } from '../../interfaces/catalogos/TipoPersonaInterface';

import { ActualizarTipoPersona, AgregarTipoPersona, TipoPersona } from '../../connections/catalogos/TipoPersonaConnection';
export const TipoPersonaPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );
    const [TipoPersonaArray, setTipoPersonaArray] = useState<TipoPersonaProps[]>( [] );
    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );
    const [idTipoPersona, setIdTipoPersona] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );
    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );
    const { filtro, setFiltro, dataFiltrada } = useFilter( TipoPersonaArray, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );
    const handleChangeChecked = async ( checked: boolean, id: number ) => {
        const TipoPersonaSelected = TipoPersonaArray.find( ( elem ) => elem.idTipoPersona === id );
        if ( TipoPersonaSelected ) {
            await ActualizarTipoPersona({ ...TipoPersonaSelected, activo: checked }).then( resp => {
                if ( resp.idTipoPersona ) {
                    var newArray = TipoPersonaArray.map( ( elem ) => {
                    if ( elem.idTipoPersona === id ) {
                        elem.activo = checked;
                    }
                        return elem;
                    });
                    setTipoPersonaArray( newArray );
                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                }
            });
        }
    }
    const handleGuardar = async () => {
        if ( idTipoPersona !== 0 ) {
            const TipoPersonaSelected = TipoPersonaArray.find( ( elem ) => elem.idTipoPersona === idTipoPersona );
            if ( TipoPersonaSelected ) {
                setLoading( true );
                await ActualizarTipoPersona({ ...TipoPersonaSelected, descripcion, }).then( resp => {
                    if ( resp.idTipoPersona ) {
                        setTimeout(() => {
                            var newArray = TipoPersonaArray.map( ( elem ) => {
                                if ( elem.idTipoPersona === idTipoPersona ) {
                                    elem.descripcion = descripcion;
                                }
                                return elem;
                            });
                            setTipoPersonaArray( newArray );
                            setOpenDialog( false );
                            setLoading( false );
                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                        }, 700);
                    }
                });
            }
        }
        else {
            const TipoPersonaAdd: TipoPersonaProps = {
                idTipoPersona: 0,
                descripcion,
                activo: true,
            }
            setLoading( true );
            await AgregarTipoPersona( TipoPersonaAdd ).then( resp => {
                if ( resp.idTipoPersona ) {
                    setTimeout(() => {
                        setTipoPersonaArray([ ...TipoPersonaArray, resp ]);
                        setOpenDialog( false );
                        setLoading( false );
                        dispatch( openSnackbar({ message: 'Se agregó el tipo de persona correctamente', variant: 'success' }));
                    }, 700);
                }
            });
        }
    }
    useEffect(() => {
        async function Obtener() {
            setLoadingData( true );
            setTipoPersonaArray( [] );
            await TipoPersona().then( resp => {

                setTimeout(() => {

                    setTipoPersonaArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }
        Obtener();
    }, [ ])
    return (
        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de persona' } ]} backgroundPaper={ false }>
            <Grid container spacing={ 3 } >
                <Grid size={{ xs: 6 }} textAlign={ 'start' }>
                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }
                </Grid>
                <Grid size={{ xs: 6 }} textAlign={ 'end' }>
                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {
                            setIdTipoPersona( 0 );
                            setDescripcion( '' );
                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>
                </Grid>
            </Grid>
            <Grid container sx={{ mt: 2 }}>
                <Grid size={{ xs: 12 }}>
                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />
                </Grid>
            </Grid>
            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>
                <Table sx={{ minWidth: 500 }}>
                    <TableHead sx={{ ...TableTheadStyle }}>
                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'75%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( { idTipoPersona, descripcion, activo } ) => (
                                <TableRow key={ idTipoPersona } >
                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        { idTipoPersona }
                                    </TableCell>
                                    <TableCell>
                                        { descripcion }
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        <Switch
                                            checked={ activo }
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idTipoPersona ) }
                                        />
                                        <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {
                                                    setIdTipoPersona( idTipoPersona );
                                                    setDescripcion( descripcion );
                                                    setOpenDialog( true );
                                                }}
                                            >
                                            <EditIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>
                                    <TableCell colSpan={ 7 } align='center'>
                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>
                                    </TableCell>
                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>
                                        <TableCell colSpan={ 7 } align='center'>
                                            <CircularProgress size={ 32 } />
                                        </TableCell>
                                    </TableRow>
                        }
                    </TableBody>
                    <TableFooter>
                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>
                                    <TableCell colSpan={ 1 } sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>
                                    <TablePagination
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        colSpan={ 8 }
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }
                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />
                                </TableRow>
                        }
                    </TableFooter>
                </Table>
            </TableContainer>
            <Dialog open={  openDialog } maxWidth='sm' fullWidth={ true }>
                <DialogContent sx={ DialogContentStyle }>
                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción' }
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>
            </Dialog>
        </Layout>
    )
}